import(/* webpackMode: "eager", webpackExports: ["LoginPage"] */ "/builds/seayatech1/aztangofest-fe/src/components/design/pages/LoginPage.tsx");
